import type { PutTechMeansDTO } from '../service/ai-disclosure.repository.interface';
import type { PutTechMeansRequest, GoalSettingWithRecommend } from '../type/ai-disclosure.type';
import { injectable, inject } from '@patsnap/tahiti-core/shared/inversify';
import { PutTechMeans } from '@/infrastructure/api-functions/interface/put-tech-means.interface';

@injectable()
export class PutTechMeansDTOImpl implements PutTechMeansDTO {
    constructor(
        @inject(PutTechMeans)
        private readonly _putTechMeansApi: PutTechMeans
    ) { }

    async fetch(value: PutTechMeansRequest): Promise<GoalSettingWithRecommend> {
        const params = {
            task_id: value.taskId,
            current_step: value.currentStep,
            tech_means: value.techMeans,
        };

        const res = await this._putTechMeansApi.putTechMeans(params);

        return {
            inventionSubject: res.invention_subject,
            applicationField: res.application_field,
            techMeans: res.tech_means,
            techEffect: res.tech_effect,
            other: res.other,
            recommendInventionSubject: res.recommend_invention_subject,
            recommendApplicationField: res.recommend_application_field,
        };
    }
}
